import Icon from "src/components/Icon";

const EmptyState = () => {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-4 rounded-md border px-6 py-6 md:w-[500px]">
      <Icon iconName="cashHistory" />

      <p className="w-full text-center text-sm text-gray-500 md:w-[300px] md:text-base">
        You haven’t received any cash gifts. You can setup your cash gifts
        registry above to start
      </p>
    </div>
  );
};

export default EmptyState;
